import { Injectable } from "@angular/core";
import { CardModel } from "src/app/shared/models/card.model";
import { SwiperOptions } from "swiper";

@Injectable({
  providedIn: "root",
})
export class HomeService {
  private readonly bandeiras: string[] = [
    "assets/img/bandeiras/logo12.png",
    "assets/img/bandeiras/logo19.png",
    "assets/img/bandeiras/logo31.png",
    "assets/img/bandeiras/logo14.png",
    "assets/img/bandeiras/logo2.png",
    "assets/img/bandeiras/logo8.png",
    "assets/img/bandeiras/logo1.png",
    "assets/img/bandeiras/logo26.png",
  ];

  private readonly cards: CardModel[] = [
    {
      img: "icone-antecipa.svg",
      title: "Antecipação de Vendas",
    },
    {
      img: "icone-pix.png",
      title: "Pix",
    },
    {
      img: "icone-cel-home.svg",
      title: "Recarga de Telefonia",
    },
    {
      img: "icon-app.svg",
      title: "App azulzinha aproxima",
    },
    {
      img: "icon-link.svg",
      title: "Link de Pagamento",
    },
    {
      img: "icon-money.svg",
      title: "Pagamento Parcial",
    },
  ];

  constructor() {}

  public getBandeiras(): string[] {
    return this.bandeiras;
  }

  public getCards(): CardModel[] {
    return this.cards;
  }
}
